import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const CardExpandArrowIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.4466 0.645105C20.6426 0.450593 20.9592 0.451807 21.1537 0.647816C21.3482 0.843824 21.347 1.16041 21.151 1.35492L11.2539 11.1764C11.2532 11.1772 11.2524 11.1779 11.2517 11.1786C11.2515 11.1788 11.2514 11.179 11.2512 11.1791C11.0797 11.3493 10.8159 11.3697 10.6223 11.2408C10.5955 11.2229 10.57 11.2022 10.5464 11.1786C10.5456 11.1779 10.5449 11.1772 10.5441 11.1764L0.647032 1.35492C0.451023 1.16041 0.44981 0.843824 0.644321 0.647816C0.838835 0.451807 1.15541 0.450593 1.35142 0.645105L10.899 10.1198L20.4466 0.645105Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </StyledSvgIcon>
);
export default CardExpandArrowIcon;

CardExpandArrowIcon.propTypes = customIconsPropTypes;
